import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { TextBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { color } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontStyle";
import { fontWeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { lineHeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/lineHeight";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { textAlign } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textAlign";
import { textDecoration } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textDecoration";
import { textTransform } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  ContentProp,
  DesignProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { fontSize } from "../../../ModifiedStyleAttributes/fontSize";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "H6",
  nameI18n: "builder_ui.block_type.h6",
  version: 1,
  isHidden: true,
  category: [TextBlock],
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    headingLevel: {
      name: "Heading level",
      nameI18n: "builder_ui.prop_type.heading_level",
      category: [ContentProp],
      prop: "other",
      type: "heading-level-picker",
      defaultValue: "h6",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        color: {
          ...color,
          type: "color-without-alpha",
          defaultValue: defaultStyles.color,
        },
        textTransform: {
          ...textTransform,
          defaultValue: defaultStyles.textTransform,
        },
        fontStyle: {
          ...fontStyle,
          defaultValue: defaultStyles.fontStyle,
        },
        fontWeight: {
          ...fontWeight,
          defaultValue: defaultStyles.fontWeight,
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.fontSize,
        },
        lineHeight: {
          ...lineHeight,
          defaultValue: defaultStyles.lineHeight,
        },
        textAlign: {
          ...textAlign,
          defaultValue: defaultStyles.textAlign,
        },
        textDecoration: {
          ...textDecoration,
          defaultValue: defaultStyles.textDecoration,
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
